<template>
  <div>
    

    <v-container id="filter-wrapper" v-if="!loading" grid-list-md fluid class="ma-0 pa-1">
      <v-layout row wrap class="ma-0 pa-0">
        <v-flex xs12>
          <div v-if="(companies.length > 1 || branches.length > 1) && !demoMode" class="content-header-minimum barometers clear">
            <div class="clear">
              <v-container grid-list-md class="pa-0" fluid>
                <v-layout row wrap>
                  <v-flex md3 xs12 v-if="companies.length > 1">
                    <v-select
                      :items="filteredCompanies"
                      :item-color="companyPrimaryColor"
                      :background-color="$vuetify.theme.themes[theme].menu"
                      item-text="name"
                      item-value="id"
                      v-on:input="loadActiveCompData()"
                      v-model="activeComp"
                      no-data-text="Geen aansluiting gevonden."
                      label="Selecteer aansluiting"
                      outlined
                      hide-details
                      dense>
                      <template v-slot:prepend-item>
                        <v-list-item>
                          <v-list-item-content  class="pt-0" >
                            <v-text-field
                              :color="companyPrimaryColor"
                              placeholder="Zoeken"
                              prepend-inner-icon="search"
                              clearable
                              background-color="background"
                              outlined
                              v-model="searchCompanies"
                              hide-details
                              dense
                            ></v-text-field>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider></v-divider>
                        <div v-if="searchCompanies && searchCompanies.length > 0" style="padding: 4px 17px 3px 17px; background-color:rgba(0,0,0, 0.02); color: rgba(0, 0, 0, 0.6); text-align: center; font-size: 12px">{{ filteredCompanies.length }} van {{ companies.length }} aansluitingen</div>
                        <v-divider v-if="searchCompanies && searchCompanies.length > 0"></v-divider>
                      </template>
                    </v-select>
                  </v-flex>
                  <v-flex md3 xs12 v-if="branches.length > 1">
                    <v-select 
                      :items="branches"
                      v-on:input="selectBranch()"
                      :item-color="companyPrimaryColor"
                      :background-color="$vuetify.theme.themes[theme].menu"
                      item-text="branchName"
                      item-value="id"
                      v-model="activeBranch"
                      label="Selecteer locatie"
                      outlined
                      hide-details
                      dense
                    >
                    </v-select>
                  </v-flex>
                  <v-flex md5 xs12 :class="{'md2': branches.length > 1}">
                     <v-alert class="ma-0" v-if="filterCustom.active" outlined text dense >Handmatige selectie: <strong>{{ filterCustom.start | moment('D MMM YYYY')}} t/m {{ filterCustom.end | moment('D MMM YYYY')}}</strong></v-alert>
                  </v-flex>
              
                  <v-flex md4 xs12 class="text-right flex" >
                    <v-alert class="ma-0 ml-2" v-if="!loading && !dataLoading && latestCall && userRole == 'superadmin' && !demoMode" outlined text dense color="success" style="display: inline-block; float: right">Laatste gesprek: <strong>{{ latestCall | moment('DD MMM YYYY')}}</strong></v-alert>
                    <v-alert class="ma-0 " v-if="!loading && !dataLoading && version === '20'" outlined text dense color="primary" style="display: inline-block; float: right;"><strong>v {{  versionCode }}</strong></v-alert>

                  </v-flex>
                </v-layout>
              </v-container>
            </div>
          </div>

          <v-card outlined v-if="!loading" class="mt-4">
            <v-container grid-list-md fluid class="ma-0 pa-1">
              <v-layout row wrap class="ma-0 pa-0">
                <v-flex xs12>
                  <v-select
                    outlined
                    class="my-2"
                    :color="companyPrimaryColor"
                    :item-color="companyPrimaryColor"
                    :items="extentions"
                    :item-text="item => `${item.number} (${item.name})`" 
             
                    item-value="id"
                    v-model="selectedExtentions"
                    multiple
                    background-color="background"
                    label="Extentions"
                    attach
                    disabled
                    hide-details
                    chips
                    return-object
                    dense
                    @change="checkExtentions()"
                    >
                    <template v-slot:prepend-item>
                        <v-list-item
                          ripple
                          @click="toggle"
                          >
                          <v-list-item-action>
                            <v-icon :color="selectedExtentions.length > 0 ? companyPrimaryColor : ''">
                              {{ icon }}
                            </v-icon>
                          </v-list-item-action>
                          <v-list-item-content>
                            <v-list-item-title>
                              <strong>Selecteer alle extentions</strong>
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      <v-divider ></v-divider>
                    </template>
                    <template v-slot:selection="{ item, index }">
                      <v-chip class="ma-1" small v-if="index === 0">{{ item.number }} <span class="extention-name" v-if="item.name"> ({{item.name}})</span></v-chip>
                      <v-chip class="ma-1" small v-if="index === 1">{{ item.number }} <span class="extention-name" v-if="item.name"> ({{item.name}})</span></v-chip>
                      <v-chip class="ma-1" small v-if="index === 2">{{ item.number }} <span class="extention-name" v-if="item.name"> ({{item.name}})</span></v-chip>
                      <v-chip class="ma-1" small v-if="index === 3">{{ item.number }} <span class="extention-name" v-if="item.name"> ({{item.name}})</span></v-chip>
                      <v-chip class="ma-1" small v-if="index === 4">{{ item.number }} <span class="extention-name" v-if="item.name"> ({{item.name}})</span></v-chip>
                      <v-chip class="ma-1" small v-if="index === 5">{{ item.number }} <span class="extention-name" v-if="item.name"> ({{item.name}})</span></v-chip>
                      <v-chip class="ma-1" small v-if="index === 6">{{ item.number }} <span class="extention-name" v-if="item.name"> ({{item.name}})</span></v-chip>
                      <v-chip class="ma-1" small v-if="index === 7">{{ item.number }} <span class="extention-name" v-if="item.name"> ({{item.name}})</span></v-chip>
                      <v-chip class="ma-1" small v-if="index === 8">{{ item.number }} <span class="extention-name" v-if="item.name"> ({{item.name}})</span></v-chip>
                      <span style="color: #666; font-size: 14px;"
                        v-if="index === 9"
                      > + {{ selectedExtentions.length - 9}} anderen 
                      </span>
                    </template>


  <!-- <template v-slot:item="{ item }">
    {{ item.number }} <span class="extention-name" v-if="item.name"> ({{item.name}})</span>
  </template> -->
                  </v-select>
                </v-flex>
                <!-- <v-flex md4 xs6>
                  <v-btn :color="todaySelected.color" darken depressed :loading="todaySelected.loading" @click="filterConversionToday()" style="margin: 0; height: 48px;" block large><span :style="{color: todaySelected.textColor}">Vandaag</span></v-btn>
                </v-flex> -->
                <v-flex md3 xs12>
                  <v-btn :color="weekSelected.color" depressed :loading="weekSelected.loading" @click="filterConversionWeek()" style="margin: 0; height: 48px;" block large><span :style="{color: weekSelected.textColor}">Deze week</span></v-btn>
                </v-flex>
                <v-flex md3 xs12>
                  <v-btn :color="monthSelected.color" depressed :loading="monthSelected.loading" @click="filterConversionMonth()" style="margin: 0; height: 48px;" block large><span :style="{color: monthSelected.textColor}">Deze maand</span></v-btn>
                </v-flex>
                <v-flex md3 xs12>
                  <v-btn :color="periodSelected.color" depressed :loading="periodSelected.loading" @click="filterConversionPeriod()" style="margin: 0; height: 48px;" block large><span :style="{color: periodSelected.textColor}">Selecteer maand</span></v-btn>
                </v-flex>
                <v-flex md3 xs12>
                  <v-btn :color="customPeriodSelected.color" depressed :loading="customPeriodSelected.loading" @click="filterConversionCustomPeriod()" style="margin: 0; height: 48px;" block large><span :style="{color: customPeriodSelected.textColor}">Selecteer periode</span></v-btn>
                </v-flex>
              </v-layout>
              <v-layout v-if="filterCustom.active" row wrap class="ma-0 pa-0">                 
                <v-flex md6 xs12>
                  <v-menu offset-y v-model="periodDatePicker" :close-on-content-click="false">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-bind="attrs"
                        v-on="on"
                          
                          v-model="dateRangeText"
                          label="Selecteer periode"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          hide-details
                          background-color="background"
                          outlined 
                          single-line
                        ></v-text-field>
                    </template>
                    <v-card>
                      <v-date-picker   
                        no-title
                        v-model="selectedDates"
                        range
                        :color="companyPrimaryColor"
                        @change="selectedDates.length == 2 ? periodDatePicker = false : null;"
                      ></v-date-picker>
                    </v-card>
                  </v-menu>

                </v-flex>
                <v-flex md6 xs12>
                  <v-btn @click="loadCustomPeriodFilter(null, null, 'custom')" :disabled="selectedDates.length < 2" :depressed="selectedDates.length < 2" :color="companySecondaryColor" style="margin: 0; height: 55px;" large block><span style="color:#fff;">Filter</span></v-btn>
                </v-flex>
              </v-layout>
              <v-layout v-if="filterPeriod" row wrap class="ma-0 pa-0">
                <v-flex md3 xs12>
                  <v-select
                    single-line
                    :color="companyPrimaryColor"
                    :item-color="companyPrimaryColor"
                    :items="activeYears"
                    label="Selecteer jaar"
                    hide-details
                    outlined
                    background-color="background"
                    v-model="selectedPeriodYear"      
                  ></v-select>
                </v-flex>
                <v-flex md6 xs12>
                  <v-select
                    single-line
                    :color="companyPrimaryColor"
                    :item-color="companyPrimaryColor"
                    :items="months"
                    item-text="name"
                    item-value="id"
                    item-disabled="disabled"
                    label="Selecteer maand"
                    hide-details
                    v-model="selectedPeriodMonth"
                    background-color="background"
                    outlined 
                  ></v-select>
                </v-flex>
                <v-flex md3 xs12>
                  <v-btn @click="loadCustomPeriodFilter(selectedPeriodMonth, selectedPeriodYear, 'filter')" :disabled="filterButtonDisabled" :depressed="filterButtonDisabled" :color="companySecondaryColor" style="margin: 0; height: 55px;" large block><span style="color:#fff;">Filter</span></v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container v-if="!dataLoading" grid-list-md fluid class="ma-0 pa-1">
      <v-layout row wrap class="ma-0 pa-0">

         <v-flex d-flex md4 sm6 xs12 v-if="activeCompData.type == 'generalPractice' && urgencyCalls && urgencyCalls.number > 0">
          <v-card outlined style="width: 100%">
            <div class="traffic-light-chart-wrapper" >
              <h3 style="font-size: 18px; padding: 0 0 10px 0;"><strong>Spoed beantwoord binnen 30 seconden</strong></h3> 
              <div class="traffic-light-chart" :class="[urgencyCalls.chartType, theme]">
                <div class="traffic-light one"></div>
                <div class="traffic-light two"></div>
                <div class="traffic-light three"></div>
                <div class="traffic-light status" :style="{'width' : urgencyCalls.chartPercentage + '%'}"></div>
              </div>
            </div>

            <v-list-item two-line>
              <v-list-item-content class="pb-0">
                <v-list-item-title >
                  <span v-if="urgencyCalls.successRate == 100" style="font-size: 55px;"><strong>{{ (urgencyCalls.successRate).toFixed(0) }}%</strong></span>
                  <span v-else style="font-size: 40px;"><strong>{{ (urgencyCalls.successRate).toFixed(1) }}%</strong></span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <div class="px-4 pb-4">
              <div><strong>is binnen de norm beantwoord</strong></div>
              <div v-if="queue.number > 0" style="font-size: 14px; padding: 5px 0 0 0;">Gemiddelde wachttijd: {{urgencyCalls.average}} </div>
              <div style="font-size: 14px; padding: 15px 0 0 0;">Aantal gesprekken: <strong>{{ urgencyCalls.number - urgencyCalls.unanswered}}</strong> </div>
              <div v-if="urgencyCalls.overTime && urgencyCalls.overTime > 0">
                <div style="font-size: 14px; padding: 5px 0 0 0;">Ogenomen binnen de norm: <strong>{{ urgencyCalls.inTime }}</strong> </div>
                <div style="font-size: 14px; padding: 0px 0 0 0;">Opgenomen buiten de norm: <strong>{{ urgencyCalls.overTime }}</strong> </div>
              </div>
              <div style="font-size: 14px; padding: 5px 0 0 0;">Langste wachttijd: <strong>{{ urgencyCalls.times[0] }}</strong> seconden </div>
              
            </div>
          </v-card>
        </v-flex>
        
         <v-flex d-flex md4 sm6 xs12 v-if="queue && queue.number > 0 && queue.number > queue.unanswered">
          <v-card outlined style="width: 100%">
            <v-list-item two-line>
              <v-list-item-content class="pb-0">
                <v-list-item-title >
                  <span style="font-size: 55px;"><strong>{{ ((queue.unanswered / queue.number)*100).toFixed(0) }}%</strong></span>
                </v-list-item-title>
              </v-list-item-content>

              <v-list-item-avatar
                class="mb-0"
                size="80"
                color="#fac4cf"
              >
                <v-icon size="45" color="#BD2846"> mdi-phone-remove</v-icon>
              </v-list-item-avatar>
            </v-list-item>
            <div class="px-4 pb-4">
              <div><strong>Gemiste gesprekken in wachtrij</strong></div>
              <div v-if="queue.number > 0" style="font-size: 14px; padding: 5px 0 0 0;">Gemiddelde wachttijd: {{queue.average}} </div>
              <div style="font-size: 14px; padding: 15px 0 0 0;">Aantal gemiste gesprekken: <strong>{{ unansweredQueueCallsNumber }}</strong> </div>
              <div v-if="unansweredQueueCallsData.success > 0" style="font-size: 14px; padding: 0px 0 0 0;">Teruggebeld met succes: <strong>{{ unansweredQueueCallsData.success }}</strong> </div>
            </div>
          </v-card>
        </v-flex>

         <v-flex d-flex md4 sm6 xs12 v-if="queue && queue.number > 0">
          <v-card outlined style="width: 100%">

            <div class="pa-3">
              <h3 style="font-size: 18px; padding: 2px 0 8px 0;"><strong>Gemiste gesprekken per dag</strong></h3> 

              <div class="unanswered-days-wrapper" v-for="(week, index) in queue.week" :key="index">
                <div class="unanswered-days">
                  <div class="unanswered-label"> {{ weekDay[index] }}: </div>
                  <div class="unanswered-number"><span v-if="week.unanswered">({{ week.unanswered }})</span></div>
                  <div class="unanswered-data-wrapper" v-if="week.number">
                    <div class="unanswered-data" :style="{width : ((week.unanswered / week.number)*100).toFixed(0) +'%'}"></div>
                    <div class="unanswered-data-number"  :class="[{'medium': (((week.unanswered / week.number)*100).toFixed(0) > 44 && ((week.unanswered / week.number)*100).toFixed(0) < 60)},{'large' : ((week.unanswered / week.number)*100).toFixed(0) > 59 }]">{{ ((week.unanswered / week.number)*100).toFixed(1) }}%</div>
                  </div>
                  <div v-else class="unanswered-data-wrapper empty">-</div>
                  <div class="expand-hours text-center" v-if="week.number" @click="expandDayHours(index)">
                    <v-icon v-if="!week.expanded">mdi-chevron-down</v-icon>
                    <v-icon v-if="week.expanded">mdi-chevron-up</v-icon>
                  </div>
                </div>

                <div class="unanswered-hours-wrapper" v-if="week.number && week.expanded">
                  <div class="unanswered-hour" v-for="(hour, i) in usedHours(week.hours)" :key="i">
                    <div class="unanswered-label hours"> {{ weekHours[hour.hour]}}: </div>
                    <div class="unanswered-number hours">({{ hour.unanswered }})</div>
                    <div class="unanswered-data-wrapper hours" v-if="hour.number">
                      <div class="unanswered-data hours " :style="{width : ((hour.unanswered / hour.number)*100).toFixed(0) +'%'}"></div>
                      <div class="unanswered-data-number hours" :class="[{'medium': (((hour.unanswered / hour.number)*100).toFixed(0) > 44 && ((hour.unanswered / hour.number)*100).toFixed(0) < 60)},{'large' : ((hour.unanswered / hour.number)*100).toFixed(0) > 59 }]">{{ ((hour.unanswered / hour.number)*100).toFixed(1) }}%</div>
                    </div>
                    <div v-else class="unanswered-data-wrapper empty">-</div>
                  </div>
                </div>
              </div>

            </div>
          </v-card>
        </v-flex>

        <v-flex d-flex md4 sm6 xs12 v-if="queue && queue.number > 0">
          <v-card outlined style="width: 100%">
            <div class="pa-3">
              <h3 style="font-size: 18px; padding: 2px 0 8px 0;"><strong>Aantal langst wachtende</strong></h3> 
              <v-chip small color="#C8E6C9" class="mr-2 mb-1">
                <strong>{{ queue.waiting.below60 }}</strong> <span style="font-size: 12px;">x</span>&nbsp;&nbsp;&lt; 1 minuut
              </v-chip><br>
              
              <v-chip small color="#FFEE58" class="mr-2 mb-1">
                <strong>{{ queue.waiting.below120 }}</strong> <span style="font-size: 12px;">x</span>&nbsp;&nbsp;&lt; 2 minuten
              </v-chip><br>

              <v-chip small color="#FFB300" class="mr-2 mb-1">
                <span style="color: #fff"><strong>{{ queue.waiting.below180 }}</strong> <span style="color: #fff; font-size: 12px;">x</span>&nbsp;&nbsp;&lt; 3 minuten</span>
              </v-chip><br>

              <v-chip small color="#E65100" class="mr-2 mb-1">
                <span style="color: #fff"><strong>{{ queue.waiting.below300 }}</strong> <span style="color: #fff; font-size: 12px;">x</span>&nbsp;&nbsp;&lt; 5 minuten</span>
              </v-chip><br>

              <v-chip small color="#BF360C" class="mr-2 mb-1">
                <span style="color: #fff"><strong>{{ queue.waiting.below600 }}</strong> <span style="color: #fff; font-size: 12px;">x</span>&nbsp;&nbsp;&lt; 10 minuten</span>
              </v-chip><br>

              <v-chip small color="#8e270e" class="mr-2 mb-1">
                <span style="color: #fff"><strong>{{ queue.waiting.below900 }}</strong> <span style="color: #fff; font-size: 12px;">x</span>&nbsp;&nbsp;&lt; 15 minuten</span>
              </v-chip><br>

              <v-chip small color="#681805" class="mr-2 mb-1">
                <span style="color: #fff"><strong>{{ queue.waiting.above900 }}</strong> <span style="color: #fff; font-size: 12px;">x</span>&nbsp;&nbsp;&gt; 15 minuten</span>
              </v-chip>
              <div class="pt-2" v-if="queue.waiting.longest" style="font-size: 14px; padding: 5px 0 0 0; color: #14363B"><i>Langst wachtende: {{queue.waiting.longest}}</i></div> 
            </div>
          </v-card>
        </v-flex>
        
        <v-flex d-flex md4 sm6 xs12 v-if="incomingCalls">
          <v-card outlined style="width: 100%">
            <v-list-item two-line>
              <v-list-item-content class="pb-0">
                <v-list-item-title >
                  <span style="font-size: 55px;"><strong>{{incomingCalls.number }}</strong></span> <span v-if="incomingCalls.unanswered" style="font-size: 14px;"> (waarvan {{incomingCalls.unanswered}} onbeantwoord)</span>
                </v-list-item-title>
              </v-list-item-content>

              <v-list-item-avatar
                class="mb-0"
                size="80"
                color="#f4f9fc"
              >
                <v-icon size="45" color="#2392CC"> mdi-phone-incoming</v-icon>
              </v-list-item-avatar>
            </v-list-item>
            <div class="px-4 pb-4">
              <div><strong>Inkomende gesprekken</strong></div>
              <div v-if="incomingCalls.number > 0" style="font-size: 14px; padding: 5px 0 0 0; color: #14363B">Gemiddelde gesprekstijd: {{incomingCalls.average}} </div> 

              <div class="unanswered-days-wrapper" v-for="(day, index) in incomingCalls.week" :key="index">
                <div class="unanswered-days">
                  <div class="unanswered-label"> {{ weekDay[index] }}: </div>
                  <div class="unanswered-number"><span v-if="day.incoming">({{ day.incoming }})</span></div>
                  <div class="unanswered-data-wrapper" v-if="day.number">
                    <div class="unanswered-data" :style="{width : ((day.incoming / incomingCalls.number)*100).toFixed(0) +'%'}"></div>
                    <div class="unanswered-data-number"  :class="[{'medium': (((day.incoming / incomingCalls.number)*100).toFixed(0) > 44 && ((day.incoming / incomingCalls.number)*100).toFixed(0) < 60)},{'large' : ((day.incoming / incomingCalls.number)*100).toFixed(0) > 59 }]">{{ ((day.incoming / incomingCalls.number)*100).toFixed(1) }}%</div>
                  </div>
                  <div v-else class="unanswered-data-wrapper empty">-</div>
                  <div class="expand-hours text-center" v-if="day.number" @click="expandDayHoursIncoming(index)">
                    <v-icon v-if="!day.expanded">mdi-chevron-down</v-icon>
                    <v-icon v-if="day.expanded">mdi-chevron-up</v-icon>
                  </div>
                </div>

                <div class="unanswered-hours-wrapper" v-if="day.number && day.expanded">
                  <div class="unanswered-hour" v-for="(hour, i) in usedHours(day.hours)" :key="i">
                    <div class="unanswered-label hours"> {{ weekHours[hour.hour]}}: </div>
                    <div class="unanswered-number hours">({{ hour.incoming }})</div>
                    <div class="unanswered-data-wrapper hours" v-if="hour.number">
                      <div class="unanswered-data hours " :style="{width : ((hour.incoming / day.number)*100).toFixed(0) +'%'}"></div>
                      <div class="unanswered-data-number hours" :class="[{'medium': (((hour.incoming / day.number)*100).toFixed(0) > 44 && ((hour.incoming / day.number)*100).toFixed(0) < 60)},{'large' : ((hour.incoming / day.number)*100).toFixed(0) > 59 }]">{{ ((hour.incoming / day.number)*100).toFixed(1) }}%</div>
                    </div>
                    <div v-else class="unanswered-data-wrapper empty">-</div>
                  </div>
                </div>
              </div>
            </div>
          </v-card>
        </v-flex>
        <v-flex d-flex md4 sm6 xs12 v-if="outgoingCalls">
          <v-card outlined style="width: 100%">
            <v-list-item two-line>
              <v-list-item-content class="pb-0">
                <v-list-item-title >
                  <span style="font-size: 55px;"><strong>{{outgoingCalls.number}}</strong></span>
                </v-list-item-title>
              </v-list-item-content>

              <v-list-item-avatar
                class="mb-0"
                size="80"
                color="#f5fdfe"
              >
                <v-icon size="45" color="#3BDBE2"> mdi-phone-outgoing</v-icon>
              </v-list-item-avatar>
            </v-list-item>
            <div class="px-4 pb-4">
              <div><strong>Uitgaande gesprekken</strong></div>
              <div v-if="outgoingCalls.number > 0" style="font-size: 14px; padding: 5px 0 0 0;">Gemiddelde gesprekstijd: {{outgoingCalls.average}} </div> 
            </div>
          </v-card>
        </v-flex>
        <v-flex d-flex md4 sm6 xs12 v-if="internalCalls">
          <v-card outlined style="width: 100%">
            <v-list-item two-line>
              <v-list-item-content class="pb-0">
                <v-list-item-title >
                  <span style="font-size: 55px;"><strong>{{internalCalls.number}}</strong></span>
                </v-list-item-title>
              </v-list-item-content>

              <v-list-item-avatar
                class="mb-0"
                size="80"
                color="#fff3d6"
              >
                <v-icon size="45" > mdi-phone-return</v-icon>
              </v-list-item-avatar>
            </v-list-item>
            <div class="px-4 pb-4">
              <div ><strong>Interne gesprekken</strong></div>
              <div v-if="internalCalls.number > 0" style="font-size: 14px; padding: 5px 0 0 0;">Gemiddelde gesprekstijd: {{internalCalls.average}} </div> 
            </div>
          </v-card>
        </v-flex>
        <v-flex d-flex md4 sm6 xs12 id="extentions-info" v-if="userRole =='superadmin' && !demoMode">
          <v-card outlined style="width: 100%">
            <div class="pt-4 px-4 pb-4">
              <div ><strong>3CX gesprekken: Extenties / Aantal </strong></div>
            </div>
            <v-list v-for="(type, name) in callTypes" :key="name" class="pa-0 ma-0">
              <v-divider></v-divider>
              <v-list-item dense>
                <v-list-item-content>
                  <v-list-item-title>
                    <span v-if="name == 'outgoing'">Uitgaand</span>
                  <span v-else>{{ type.destination }}</span>
                  </v-list-item-title>
                </v-list-item-content>

                <v-list-item-action>
                  <strong>{{ type.counter}}</strong>
                </v-list-item-action>
              </v-list-item>    
            </v-list>
          </v-card>
        </v-flex>

        <v-flex d-flex md4 sm6 xs12 id="extentions-info" v-if="userRole =='superadmin' && !demoMode">
          <v-card outlined style="width: 100%">
            <div class="pt-4 px-4 pb-4">
              <div ><strong>3CX Action Types</strong></div>
            </div>
            <v-list v-for="(call, index) in callsSorterd" :key="index" class="pa-0 ma-0">
              <v-divider></v-divider>
              <v-list-item dense>
                <v-list-item-content>
                  <v-list-item-title>
                    Type: {{ call.CallType }} - {{ call.Reason }}
                  </v-list-item-title>
                </v-list-item-content>

                <v-list-item-action>
                  <strong> {{ call.count }}</strong>
                </v-list-item-action>
              </v-list-item>    
            </v-list>
          </v-card>
        </v-flex>
        <v-flex d-flex lg8 md12 xs12 v-if="!callSubjectsLoading && chartSeries[0].data.length > 0">
          <v-card outlined class="pb-2" style="width: 100%">
            <div class="px-4 pt-4">
              <div><strong>Type gesprekken</strong></div>   
              <div style="font-size: 14px; padding: 5px 0 0 0;">Aantal geregistreerde gesprekken: <strong>{{ callSubjects.length }} </strong> 
                <span v-if="incomingCalls.number"> ({{ ((callSubjects.length/incomingCalls.number)*100).toFixed(0)}}%)</span>
              </div>

                     
            </div>
            <apexchart type="bar" width="100%" :height="chartHeight" :options="chartOptions" :series="chartSeries"></apexchart>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>



    <div v-if="dataLoading && !loading" class="fancy-loader"></div>

    <div class="no-data" v-if="!dataLoading && !loading && noDataLogs && noDataPopup">
      <div class="medical-image" :class="randomMedical"></div>
      <p>Geen data gevonden.</p>
    </div>


  </div>
</template>

<script>
import firebase from "firebase/app";
import db from "../firebase/init";
// import { bus } from "../main";
import axios from "axios";
import moment from "moment";
import slugify from "slugify";
// import momenttz from "moment-timezone";
import _ from "lodash";
//import { BigQuery } from '@google-cloud/bigquery';

export default {
  name: "Dashboard",

  data: () => ({
    loading: true,
    dataLoading: true,
    token: null,
    filterToday: true,
    filterWeek: false,
    filterMonth: false,
    filterPeriod: false,
    selectedPeriodDay: "01",
    selectedPeriodYear: moment().year(),
    selectedPeriodMonth: Number(moment().format("M")),
    selectedDates: [],
    periodDatePicker: false,
    activeComp: null,
    activeCompData: {},
    activeCompDataOriginal: null,

    companies: [],
    branches: [],
    activeBranch: [],
    extentions: [],
    selectedExtentions: [],
    weekDay: [
      "Zondag",
      "Maandag",
      "Dinsdag",
      "Woensdag",
      "Donderdag",
      "Vrijdag",
      "Zaterdag"
    ],

    weekHours: [
      "00:00 - 01:00u",
      "01:00 - 02:00u",
      "02:00 - 03:00u",
      "03:00 - 04:00u",
      "04:00 - 05:00u",
      "05:00 - 06:00u",
      "06:00 - 07:00u",
      "07:00 - 08:00u",
      "08:00 - 09:00u",
      "09:00 - 10:00u",
      "10:00 - 11:00u",
      "11:00 - 12:00u",
      "12:00 - 13:00u",
      "13:00 - 14:00u",
      "14:00 - 15:00u",
      "15:00 - 16:00u",
      "16:00 - 17:00u",
      "17:00 - 18:00u",
      "18:00 - 19:00u",
      "19:00 - 20:00u",
      "20:00 - 21:00u",
      "21:00 - 22:00u",
      "22:00 - 23:00u",
      "23:00 - 24:00u"
    ],  
    searchCompanies: "",
    noDataLogs: false,
    noDataPopup: false,
    calls: [],
    callTypes: new Object(),
    callDataPeriodType: 'day',
    callDataPeriodStart: null,
    callDataPeriodEnd: null,
    callPhones: [],
    callQueues: [],
    internalCalls: null,
    queue: null,
    outgoingCalls: null,
    incomingCalls: null,
    callSubjects: [],
    callSubjectsLoading: true,
    filterCustom: {
      active: false,
      start: null,
      end: null
    },
    callsSorterd: new Array(),
    versionCode: null,

    compStartYear: null,
    compStartMonth: null,

    chartOptions: { 
      chart: { 
        height: 250,
        type: 'bar',
        toolbar: {
          show: false,
        },
      },
       
      plotOptions: {
        bar: {
          barHeight: '100%',
          distributed: true,
          horizontal: true,
          dataLabels: {
            position: 'bottom'
          },
        }
      },
      grid: {
        show: false,
      },
      colors: ['#9bbde4', '#87bbd3','#c7edff','#8fdbff','#db7cad','#c186a5','#aca682','#dfd489','#e3c81c','#fffbc7'],   
      tooltip: {
        enabled: true,
        fillSeriesColor: false,
        theme: 'light',
        y: {
          show: true,
          formatter: function(value) {
            return value.toFixed(0);
          }
        }
      },
      labels: [],
      xaxis: {
        categories: [],
       
        axisTicks: {
          show: false
        },
        labels: {
          show: true,
          formatter: function(value) {
            return value.toFixed(0);
          }
        },
        tickAmount: 10,
      },
      dataLabels: {
        enabled: true,
        textAnchor: 'start',
        style: {
          colors: ['#333']
        },
        formatter: function (val, opt) {
          // return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val
          return opt.w.globals.labels[opt.dataPointIndex]
        },
        offsetX: 0,
        dropShadow: {
          enabled: false,
          color: '#fff',
          opacity: 0.45
        }
      },
      stroke: {
        width: 3,
        colors: ['#fff']
      },
      yaxis: {
        labels: {
          show: false
        },
        axisBorder: {
          show: false,
        },
        
      },
      // legend: {
      //   position: 'right',
      //   horizontalAlign: 'left', 
      //   fontSize: '16px',
      // },
      // responsive: [{
      //   breakpoint: 600,
      //   options: {
      //     legend: {
      //       position: 'bottom',
      //       horizontalAlign: 'left', 
      //       fontSize: '14px',
      //     },
      //   },
      // }]
      
    },
    latestCall: null,
    queueCalls: [],
    urgencyCalls: [],
    callPhonesUrgency: [],
    unansweredQueueCallsNumber: 0,
    unansweredQueueCalls: [],
    unansweredQueueCallsData: {
      success: 0,
      failed:0
    },
    chartSeries: [{
      name: 'Aantal gesprekken',
      data: []
    }],
    chartWidth: "100%",
    chartHeight: 'auto',

    popupChartLabels: {},
  }),

  created() {
    this.loadUserComp()
    // this.calculateChartWidth();
    // window.addEventListener("resize", this.calculateChartWidth);
  },

  mounted() {},

  methods: {
    calculateChartWidth(){
      let windowWidth = document.documentElement.clientWidth;

      if(windowWidth < 850){
        this.chartWidth = "100%"
      }
      else{
        if(this.chartOptions.labels.length > 5){
          this.chartWidth = "100%"
        }
        else{
          this.chartWidth = 600;
        } 
      }

    },

    loadUserComp() {     
      this.loaded = false;
      // let userCompanies = this.userCompanies;
      this.companies = [];
      let counter = 0


      new Promise((resolve)=>{
        if(this.userRole == 'superadmin'){
          db.collection("companies")
          .where("deleted.deleted", "==", false)
          .get()
          .then(snap => {
            this.companies = [];
            snap.forEach(doc => {
              let company = doc.data();
              company.id = doc.id;
              this.companies.push(company);
            });
          })
          .then(()=>{
            resolve();
          })
        }
        else{
          this.userCompanies.forEach(company=>{
          db.collection("companies").doc(company.id).get()
            .then(doc => {
              let company = {};
              company.name = doc.data().name;
              company.id = doc.id;
              this.companies.push(company);
              counter++
              if(counter == this.userCompanies.length){
                resolve()
              }
            })
          })
        }
      })
      .then(()=>{
        // REMEMBER SELECTED COMPANY FROM LOCAL STORAGE
        if(this.userRole == 'superadmin'){
          // Super Admins have access to multiple companies 
          let selectedCompany = window.localStorage.getItem('selectedCompany')

          // Check if a selected company is set in the Local Storage
          if(selectedCompany){ 
            // Check if the selected company is an option
            let selectedCompanyIndex = this.companies.findIndex(company => company.id === selectedCompany)

            // _.findIndex(this.companies, { 'id': selectedCompany })

            // Selected company is an option, set activeComp
            if(selectedCompanyIndex >= 0){
              this.activeComp = this.companies[selectedCompanyIndex].id;
              this.loadActiveCompData();
            } 
            // Selected company is no option, set first company as activeComp 
            else{
              this.activeComp = this.companies[0].id;
              window.localStorage.setItem('selectedCompany', this.companies[0].id)
              this.loadActiveCompData();
            }
          }
          // No selected company is set 
          else {
            +2
            this.activeComp = this.companies[0].id;
            window.localStorage.setItem('selectedCompany', this.companies[0].id)
            this.loadActiveCompData();
          }
        }

        // Regular users have 1 company, just get the first
        else {
          this.activeComp = this.companies[0].id;
          this.loadActiveCompData();
        }
      })
    },

    async loadActiveCompData() {
      this.loading = true;
      this.token = null;
      // Set Active Company as Selected Company in Local Storage
      window.localStorage.setItem('selectedCompany', this.activeComp)
      await db.collection("companies")
        .doc(this.activeComp)
        .get()
        .then(doc => {
          if (doc.exists) {
            this.activeCompData = doc.data();
            this.activeCompData.id = doc.id;
            if(doc.data().created){
              this.compStartYear = moment.unix(doc.data().created.seconds).format("YYYY")
              this.compStartMonth = moment.unix(doc.data().created.seconds).format("M")
            } else {
              this.compStartYear = moment().year()
              this.compStartMonth = moment().month()
            }
          } else {
            console.log("No such document!");
          }
        })
        .catch(error => {
          this.loading = false;
          this.error = true;
          console.error("Error getting company data:", error);
        });
        this.activeCompDataOriginal = _.cloneDeep(this.activeCompData);
        await this.get3CXtoken();
        this.getPopupData();
        this.loadBranches();
        this.loadExtentions();  
        this.loading = false;
    },

    selectBranch(){
      window.localStorage.setItem(`selectedBranch${this.activeComp}`, this.activeBranch)
      this.loadExtentions();
    },

    async get3CXtoken(){
      this.token = null;
      this.version = '19';
      if(this.activeCompData['3cxSettings']){
        if(this.activeCompData['3cxSettings'].user && this.activeCompData['3cxSettings'].url && this.activeCompData['3cxSettings'].pw){
          const config = {
            headers: {"Content-Type": "application/json"},
          };

          const jsonAuth = {  
            SecurityCode:"",
            username: this.activeCompData['3cxSettings'].user,
            password: this.activeCompData['3cxSettings'].pw,
            url: this.activeCompData['3cxSettings'].url
          };

          this.token = null;

          await axios
          //.post(`http://localhost:8908/auth/3cx/v20`, jsonAuth, config) 
          .post(`https://connection3cx.hogans.nl/auth/3cx/v20`, jsonAuth, config) 
          .then((response) => {
            this.token = response.data 
            // console.log("token: ", this.token)
            this.version = '20';
          })
          .catch((error) => {
            console.error("3CX-login error => " + error);
          });

          
        }
      }      
      return
    },

    async loadExtentions() {
      this.extentions = [];
      this.selectedExtentions = [];  

      await db.collection("extentions")
      .where("compId", "==", this.activeComp)
      .get()
      .then(snap => {
        this.extentions = [];
        snap.forEach(doc => {
          let extention = doc.data();
          extention.id = doc.id;
          
          if(extention.branch == this.activeBranch){
            this.extentions.push(extention);
            this.selectedExtentions.push(extention);
          }
        });
      })
      
      this.extentions = _.orderBy(this.extentions, ['number'], ['asc']);
      this.selectedExtentions = _.orderBy(this.selectedExtentions, ['number'], ['asc']);

      if(this.$route.query.start && this.$route.query.end && (this.userRole == 'admin' || this.userRole == 'superadmin' )){
        this.filterConversionCustom()
      }
      else{
        this.filterConversionWeek()
      }

    },

    loadBranches() {
      // Load branches
      this.branches = [];

      db.collection("branches")
        .where("compId", "==", this.activeComp)
        .get()
        .then(snap => {
          snap.forEach(doc => {
            let branchCollection = doc.data();
            branchCollection.id = doc.id;
            
            if(this.userRole == 'superadmin'){
              this.branches.push(branchCollection);
            }
            else{
              let branchIndex = this.userBranches.findIndex(branch => branch.id === branchCollection.id);
              if(branchCollection.id && branchIndex >= 0){
                this.branches.push(branchCollection);
              }
            }  
          });
        })
        .then(()=>{
          let selectedBranch = window.localStorage.getItem(`selectedBranch${this.activeComp}`)
          // Check if a selected branch is set in the Local Storage
          if(selectedBranch){ 
            // Check if the selected branch is an option
            let selectedBranchIndex = this.branches.findIndex(branch => branch.id === selectedBranch)
            // let selectedBranchIndex = _.findIndex(this.branches, { 'id': selectedBranch })

            // Selected branch is an option, set activeComp
            if(selectedBranchIndex >= 0){
              this.activeBranch = this.branches[selectedBranchIndex].id;
            } 
            // Selected branch is no option, set first branch as activeComp 
            else{
              
              this.activeBranch = this.branches[0].id;
              window.localStorage.setItem(`selectedBranch${this.activeComp}`, this.branches[0].id)
            }
          }
          // No selected branch is set 
          else {
            this.activeBranch = this.branches[0].id;
            window.localStorage.setItem(`selectedBranch${this.activeComp}`, this.branches[0].id)
          }

          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          this.error = true;
          console.error("Error getting branches:", error);
        });
    },

    getPopupData(){
      this.popupChartLabels = {};
      this.popupChartLabels[this.activeCompData.type] = {};

      db.collection("callTypes")
        .where('companyType', '==', this.activeCompData.type)
        .get()
        .then(snap => {
          this.mainCallTypes = [];
          this.otherCallTypes = [];
          snap.forEach(doc => {
            let callType = doc.data();
            callType.docId = doc.id;
            this.popupChartLabels[this.activeCompData.type][callType.id] = callType.name;
          });
        })
    },

    isValidDate(str) {
      var d = moment(str,'YYYY-MM-DD');
      if(d == null || !d.isValid()) return false;

      return str.indexOf(d.format('YYYY-MM-DD')) >= 0 
          || str.indexOf(d.format('YYYY/M/D')) >= 0;
    },

    filterConversionCustom(){
      let start = this.$route.query.start;
      let end = this.$route.query.end;
      let firstDate = moment(start).format("YYYY-MM-DD");
      let lastDate = moment(end).format("YYYY-MM-DD");

      if(this.isValidDate(start) && this.isValidDate(end) && end > start){ // Query data zijn geldig
        this.filterToday = false;
        this.filterCustom = {
          active: true,
          start:moment(firstDate).format('YYYY-MM-DD'),
          end: moment(lastDate).format('YYYY-MM-DD')
        };
        this.filterWeek = false;
        this.filterMonth = false;
        this.filterPeriod = false;
        
        this.queryCallLogs(firstDate, lastDate, 'custom');
      }
      else{
        console.log("Data zijn niet geldig")
        this.filterConversionWeek()
      }
    },

    filterConversionToday(){
      this.filterToday = true;
      this.filterWeek = false;
      this.filterMonth = false;
      this.filterPeriod = false;
      this.filterCustom.active = false;
      let firstDate = moment().startOf('day').format("YYYY-MM-DD");
      let lastDate = moment().endOf('day').add(1, 'day').format("YYYY-MM-DD");
  
      // this.loadCallDataDate(firstDate, lastDate, 'day');
      this.queryCallLogs(firstDate, lastDate, 'day');
    },

    filterConversionWeek(){
      this.filterToday = false;
      this.filterWeek = true;
      this.filterMonth = false;
      this.filterPeriod = false;
      this.filterCustom.active = false;
      let firstDate = moment().weekday(0).format("YYYY-MM-DD");
      let lastDate = moment().weekday(7).add(1, 'day').format("YYYY-MM-DD");
  
      //this.loadCallDataDate(firstDate, lastDate, 'week');
      this.queryCallLogs(firstDate, lastDate, 'week');
    },

    filterConversionMonth(){
      this.filterToday = false;
      this.filterWeek = false;
      this.filterMonth = true;
      this.filterPeriod = false;
      this.filterCustom.active = false;
      let firstDate = moment().startOf('month').format("YYYY-MM-DD");
      let lastDate = moment().endOf('month').add(1, 'days').format("YYYY-MM-DD");

      //this.loadCallDataDate(firstDate, lastDate, 'month');
      this.queryCallLogs(firstDate, lastDate, 'month');
    },

    filterConversionPeriod(){
      this.filterToday = false;
      this.filterWeek = false;
      this.filterMonth = false;
      this.filterPeriod = true;
      this.filterCustom.active = false;
    },

    filterConversionCustomPeriod(){
      this.filterToday = false;
      this.filterWeek = false;
      this.filterMonth = false;
      this.filterPeriod = false;
      this.filterCustom.active = true;
    },

    toggle () {
      this.$nextTick(() => {
        if (this.selectAllExtentions) {
          this.selectedExtentions = new Array();
        } else {
          this.selectedExtentions = this.extentions.slice()
        }
      })
    },

    loadCustomPeriodFilter(start, end, filter){
      if(filter == 'url'){
        //this.loadCallDataDate(start, end, 'month')
        this.queryCallLogs(start, end, 'month')

      }
      else if(filter == 'custom'){
        let firstDate = this.selectedDates[0];
        let lastDate = moment(this.selectedDates[1]).add(1, 'day').format("YYYY-MM-DD");
        this.filterCustom.start = firstDate;
        this.filterCustom.end = lastDate;

        //this.loadCallDataDate(firstDate, lastDate, 'month');
        this.queryCallLogs(firstDate, lastDate, 'custom');
      }
      
      else {
        this.selectedPeriodDay = '01'
        let selectedDate = this.selectedPeriodYear+"-"+this.selectedPeriodMonth+"-01"
        let firstDate = moment(selectedDate).startOf('month').format("YYYY-MM-DD");
        let lastDate = moment(selectedDate).endOf('month').add(1, 'days').format("YYYY-MM-DD");

        //this.loadCallDataDate(firstDate, lastDate, 'month');
        this.queryCallLogs(firstDate, lastDate, 'month');
      }
    },
    
    async queryCallLogs(firstDate, lastDate, type) {
      this.latestCall = null;
      this.dataLoading = true;
      this.calls = [];
      
      this.callSubjects = [];
      this.callSubjectsLoading = true;
      
      this.versionCode = null;
      if(this.token){ // Load Call Logs From 3CX
        const versionData = {
          url: this.activeCompData['3cxSettings'].url,
          accessToken: this.token
        };
        await axios
          //.post(`http://localhost:8908/auth/3cx/version`,versionData) 
          .post(`https://connection3cx.hogans.nl/auth/3cx/version`, versionData) 
          .then((response) => {
            this.versionCode = response.data
          })
          .catch((error) => {
            console.error("3CX-login error => " + error);
          });

        this.filterCallData(firstDate, lastDate)
        // let data = {
        //   url: this.activeCompData['3cxSettings'].url,
        //   accessToken: this.token,
        //   start: moment(firstDate).format("YYYY-MM-DDTHH:mm:ss") + ".000Z", // 2025-01-10T23:59:59.000Z
        //   end: moment(lastDate).format("YYYY-MM-DDTHH:mm:ss") + ".000Z" // 2025-01-10T23:59:59.000Z
        // };
        
        

        

        // this.calls = new Array();
        // await axios
        // // .post(`http://localhost:8908/3cx/callLogs/`, data, )
        // .post(`https://connection3cx.hogans.nl/3cx/callLogs/`, data, )
        // .then((response) => {
        //   // console.log("response =>", response.data);
        //   // this.calls = response.data.value.filter(activeCall => activeCall.Callee.split(' ')[0] === extensionNumber);
        //   this.calls = response.data.value;
        //   const zone = 'Europe/Amsterdam';
        //   let latestDate = moment(this.calls[this.calls.length - 1].StartTime)
        //   this.latestCall = moment(latestDate, zone).utc().format("YYYY-MM-DD HH:mm");
        // })
        // .catch((error) => {     
        //   console.log("3CX calllogs v20:", error)
        // });

        // console.log("calls =>", this.calls.length)
        // this.callSorter();
        // this.checkExtentions();
      }
      else{ // Load Call Logs From Big Query ( Version < 20)
        firebase.auth().currentUser.getIdToken(true)
          .then(idToken=> {
            let data = JSON.stringify({
              token: idToken,
              companyId: this.activeCompData.id,
              type: "logs",
              compType: this.activeCompData.type,
              start: firstDate,
              end: lastDate
            })
            var config = {
              method: 'post',
              url: 'https://query.hogans.nl/getCallData',
              headers: { 
                'Content-Type': 'application/json'
              },
              data : data
            };
            axios(config)
            .then(response=> {
              this.calls = response.data;
              if(this.calls.length > 0){
                const zone = 'Europe/Amsterdam';
                let latestDate = moment(this.calls[this.calls.length - 1].timestamp.value)
                this.latestCall = moment(latestDate, zone).utc().format("YYYY-MM-DD HH:mm");
              }
              this.checkExtentions();
            })
            .catch(error=> {
              console.error("Error getting data from bigquery: ", error);
              console.error(error.response.data);
            });

          })
        .catch(error=> {
          console.error("Error getting ID Token", error);
        });
      }

      // Load Call Popup Data
      firebase.auth().currentUser.getIdToken(true)
        .then(idToken=> {
          let data = JSON.stringify({
            token: idToken,
            companyId: this.activeCompData.id,
            type: "popup",
            compType: this.activeCompData.type,
            start: firstDate,
            end: lastDate
          })
          var config = {
            method: 'post',
            url: 'https://query.hogans.nl/getCallData',
            headers: { 
              'Content-Type': 'application/json'
            },
            data : data
          };
          axios(config)
          .then(response=> {
            this.callSubjects = response.data;
            this.filterCallSubjects();
          })
          .catch(error=> {
            console.error(error.response.data);
          });

        })
      .catch(error=> {
        console.error("Error getting ID Token", error);
      });



    },

    callSorter(){
      this.callsSorterd = Object.values(
        this.calls.reduce((acc, {CallType, Reason}) => {
          if(!acc[CallType]) {
            acc[CallType] = { CallType, Reason, count: 1 };
          } else {
            acc[CallType].count++;
            acc[CallType].Reason = Reason; // Update met laatste reden
          }
          return acc;
        }, {})
      ).sort((a, b) => b.count - a.count);
      // this.callsSorterd = Object.values(
      //   this.calls.reduce((acc, {ActionType, Reason}) => {
      //     if(!acc[ActionType]) {
      //       acc[ActionType] = { ActionType, Reason, count: 1 };
      //     } else {
      //       acc[ActionType].count++;
      //       acc[ActionType].Reason = Reason; // Update met laatste reden
      //     }
      //     return acc;
      //   }, {})
      // ).sort((a, b) => b.count - a.count);
      
    },

    expandDayHours(dayIndex){
  
      for (const [key, value] of Object.entries(this.queue.week)) {
        if(key == dayIndex){
          if(value.expanded){
            value.expanded = false;
          }
          else{
            value.expanded = true;
          }
        }
        else{
          value.expanded = false;
        }
      }
    },

    expandDayHoursIncoming(dayIndex){
      for (const [key, value] of Object.entries(this.incomingCalls.week)) {
        if(key == dayIndex){
          if(value.expanded){
            value.expanded = false;
          }
          else{
            value.expanded = true;
          }
        }
        else{
          value.expanded = false;
        }
      }
    },

    usedHours(hours){
      let filteredHours = []
      for (const [key, value] of Object.entries(hours)) {
        if(value.number){
          filteredHours.push(value);
        }
      }
      return filteredHours;
    },

    
    checkExtentions(){
      this.selectedExtentions = _.orderBy(this.selectedExtentions, ['number'], ['asc']);
      this.callPhones = []
      this.callQueues = [];
      this.callPhonesUrgency = [];

      this.selectedExtentions.forEach(extention=>{
        if(extention.type == 'queue'){
          this.callQueues.push(extention)
        }
        else if(extention.type == 'landLine' || extention.type == 'mobilePhone'){
          this.callPhones.push(extention)
        }
        else if(extention.type == 'urgency'){
          this.callPhonesUrgency.push(extention)
        }
      })
      if(this.version === '20'){
        this.filterCallData();
      }
      else{
        this.filterCallDataBigQuery();
      }
      
    },

    /**
     * Check Incoming Calls with 3CX API data (3CX version > 19 solution)
     */

     async checkIncomingCall(type, data){

      // console.log("checkIncomingCall: ", type , data)
      let valid = false;
      let counter = 0;
      await new Promise((resolve)=>{
        if(type == 'queue'){
          if(this.callQueues.length > 0){
            this.callQueues.forEach(queue=>{
              if(data == queue.number){
                valid = true;
              }
              counter++
              if(counter == this.callQueues.length){
                resolve();
              }
            })
          }
          else{
            resolve();
          }
        }
        if(type == 'phone'){
          if(this.callPhones.length > 0){
            this.callPhones.forEach(phone=>{
              if(data){
                if(data == phone.number){
                  valid = true;
                }
              }
              counter++
              if(counter == this.callPhones.length){
                resolve();
              }
            })
          }
          else{
            resolve();
          }
        }
        if(type == 'urgency'){
          if(this.callPhonesUrgency.length > 0){
            this.callPhonesUrgency.forEach(phone=>{
              if(data){
                if(data == phone.number){
                  valid = true;
                }
              }
              counter++
              if(counter == this.callPhonesUrgency.length){
                resolve();
              }
            })
          }
          else{
            resolve();
          }
        }
      })
      return valid;
      },


      resetData(){
        let hours = {
        0:{ hour: 0, number: 0, unanswered:0, incoming:0},
        1:{ hour: 1, number: 0, unanswered:0, incoming:0},
        2:{ hour: 2, number: 0, unanswered:0, incoming:0},
        3:{ hour: 3, number: 0, unanswered:0, incoming:0},
        4:{ hour: 4, number: 0, unanswered:0, incoming:0},
        5:{ hour: 5, number: 0, unanswered:0, incoming:0},
        6:{ hour: 6, number: 0, unanswered:0, incoming:0},
        7:{ hour: 7, number: 0, unanswered:0, incoming:0},
        8:{ hour: 8, number: 0, unanswered:0, incoming:0},
        9:{ hour: 9, number: 0, unanswered:0, incoming:0},
        10:{ hour: 10, number: 0, unanswered:0, incoming:0},
        11:{ hour: 11, number: 0, unanswered:0, incoming:0},
        12:{ hour: 12, number: 0, unanswered:0, incoming:0},
        13:{ hour: 13, number: 0, unanswered:0, incoming:0},
        14:{ hour: 14, number: 0, unanswered:0, incoming:0},
        15:{ hour: 15, number: 0, unanswered:0, incoming:0},
        16:{ hour: 16, number: 0, unanswered:0, incoming:0},
        17:{ hour: 17, number: 0, unanswered:0, incoming:0},
        18:{ hour: 18, number: 0, unanswered:0, incoming:0},
        19:{ hour: 19, number: 0, unanswered:0, incoming:0},
        20:{ hour: 20, number: 0, unanswered:0, incoming:0},
        21:{ hour: 21, number: 0, unanswered:0, incoming:0},
        22:{ hour: 22, number: 0, unanswered:0, incoming:0},
        23:{ hour: 23, number: 0, unanswered:0, incoming:0}
      }

      let queue = {
        number: 0,
        seconds: 0,
        unanswered: 0,
        week: {
          0:{
            number: 0,
            unanswered:0,
            hours: _.cloneDeep(hours),
            expanded: false
          },
          1:{
            number: 0,
            unanswered:0,
            hours: _.cloneDeep(hours),
            expanded: false
          },
          2:{
            number: 0,
            unanswered:0,
            hours: _.cloneDeep(hours),
            expanded: false
          },
          3:{
            number: 0,
            unanswered:0,
            hours: _.cloneDeep(hours),
            expanded: false
          },
          4:{
            number: 0,
            unanswered:0,
            hours: _.cloneDeep(hours),
            expanded: false
          },
          5:{
            number: 0,
            unanswered:0,
            hours: _.cloneDeep(hours),
            expanded: false
          },
          6:{
            number: 0,
            unanswered:0,
            hours: _.cloneDeep(hours),
            expanded: false
          }
        },
        unansweredWeek: 0,
        waiting: {
          longest: null,
          list: [],
          below60: 0,
          below120: 0,
          below180: 0,
          below300: 0,
          below600: 0,
          below900: 0,
          above900: 0
        }
      }

      let outgoingCalls = {
        number: 0,
        seconds: 0,
        unanswered: 0
      }

      let internalCalls = {
        number: 0,
        seconds: 0,
        unanswered: 0
      }


      let incomingCalls = {
        number: 0,
        seconds: 0,
        unanswered: 0,
        incoming: 0,
        logs: [],
        week: {
          0:{
            number: 0,
            incoming:0,
            hours: _.cloneDeep(hours),
            expanded: false
          },
          1:{
            number: 0,
            incoming:0,
            hours: _.cloneDeep(hours),
            expanded: false
          },
          2:{
            number: 0,
            incoming:0,
            hours: _.cloneDeep(hours),
            expanded: false
          },
          3:{
            number: 0,
            incoming:0,
            hours: _.cloneDeep(hours),
            expanded: false
          },
          4:{
            number: 0,
            incoming:0,
            hours: _.cloneDeep(hours),
            expanded: false
          },
          5:{
            number: 0,
            incoming:0,
            hours: _.cloneDeep(hours),
            expanded: false
          },
          6:{
            number: 0,
            incoming:0,
            hours: _.cloneDeep(hours),
            expanded: false
          }
        },
      }

      let urgencyCalls = {
        number: 0,
        seconds: 0,
        unanswered: 0,
        inTime: 0,
        overTime: 0,
        times: [],
        average: null,
        successRate: null,
        chartPercentage: 0,
        chartType: null
      }
      this.incomingCalls = incomingCalls;
      },
    /**
     * Filter Saved Data (3CX version > 19 solution with data from API)
     */

    async filterCallData(firstDate, lastDate) {
      // console.log("filterCallData =>", firstDate, lastDate)
        // Initialize all data structures at once
      const config = {
            headers: {"Content-Type": "application/json"},
          };
      let data = {
        companyId: this.activeComp,
        branchId: this.activeBranch,
        url: this.activeCompData['3cxSettings'].url,
        accessToken: this.token,
        start: firstDate,
        end: lastDate
      };
      this.resetData();
      
      // const callLogs = await axios.post(`http://localhost:8908/3cx/callLogsFormatted/`, data, config)
      const callLogs = await axios.post(`https://connection3cx.hogans.nl/3cx/callLogsFormatted/`, data, config)

      this.incomingCalls = callLogs.data.total.incomingCalls;
      this.outgoingCalls = callLogs.data.total.outgoingCalls;
      this.internalCalls = callLogs.data.total.internalCalls;
      this.queue = callLogs.data.total.queue;
      this.urgencyCalls = callLogs.data.total.urgencyCalls;
      this.unansweredQueueCallsNumber = callLogs.data.total.unansweredQueueCallsNumber;
      this.unansweredQueueCallsData = callLogs.data.total.unansweredQueueCallsData;
      // this.callTypes = callLogs.data.callTypes;
      this.dataLoading = false;
      

    },

    // Helper methods
    processBatch(batch, data) {
        return Promise.all(batch.map(call => this.processCall(call, data)));
    },

    async processCall(call, data) {
        const checks = await Promise.all([
            this.checkIncomingCall('phone', call.SourceDn),
            this.checkIncomingCall('phone', call.DestinationDn),
            this.checkIncomingCall('queue', call.DestinationDn),
            this.checkIncomingCall('urgency', call.DestinationDn)
        ]);
      
        const [companyOutgoing, companyIncoming, companyQueue, companyUrgency] = checks;
        const seconds = this.extractSeconds(call.TalkingDuration);
 
        // Update call types
        this.updateCallTypes(call, data.callTypes);
        
        // Process call based on type
        if ((companyOutgoing && companyIncoming) || (companyOutgoing && companyQueue)) {
            this.processInternalCall(call, seconds, data);
        } else if (companyOutgoing) {
            this.processOutgoingCall(call, seconds, data);
        } else if (companyIncoming || companyQueue) {
            this.processIncomingOrQueueCall(call, seconds, data, companyQueue);
        } else if (companyUrgency) {
            this.processUrgencyCall(call, seconds, data);
        }
    },

    extractSeconds(duration) {
      
      if(duration && duration != undefined){
        const secondsMatch = duration.replace('PT', '').match(/([\d.]+)S/);
        return secondsMatch ? parseFloat(secondsMatch[1]) : 0;
      }
      else{
        return 0;
      }
    },

    /**
     * Check Incoming Calls with BigQuery data (3CX version < 20 solution)
     */

    async checkIncomingCallBigQuery(type, data){
      let valid = false;
      let counter = 0;

      await new Promise((resolve)=>{
        if(type == 'queue'){
          if(this.callQueues.length > 0){
            this.callQueues.forEach(queue=>{
              if(data.includes("("+queue.number+")")){
                valid = true;
              }
              counter++
              if(counter == this.callQueues.length){
                resolve();
              }
            })
          }
          else{
            resolve();
          }
        }
        if(type == 'phone'){
          if(this.callPhones.length > 0){
            this.callPhones.forEach(phone=>{
              if(data.includes("("+phone.number+")")){
                valid = true;
              }
              counter++
              if(counter == this.callPhones.length){
                resolve();
              }
            })
          }
          else{
            resolve();
          }
        }
        if(type == 'urgency'){
          if(this.callPhonesUrgency.length > 0){
            this.callPhonesUrgency.forEach(phone=>{
              if(data.includes("("+phone.number+")")){
                valid = true;
              }
              counter++
              if(counter == this.callPhonesUrgency.length){
                resolve();
              }
            })
          }
          else{
            resolve();
          }
        }
      })
      return valid;
    },
    

    /**
     * Filter Saved Data from the BigQuery (3CX version < 20 solution)
     */
    filterCallDataBigQuery(){
      this.noDataLogs = false;
      this.dataLoading = true;
      this.internalCalls = null;
      this.queue = null;
      this.outgoingCalls = null
      this.incomingCalls = null;
      this.unansweredQueueCalls = [];
      this.unansweredQueueCallsData.success = 0;
      this.unansweredQueueCallsData.failed = 0;
      this.queueCalls = [];
      this.urgencyCalls = new Object();

      // this.callTypes = _.uniqBy(this.calls, 'destination');
      this.callTypes = new Array();
      let callTypes = new Object();

      this.calls.forEach(call=>{
        let numb = call.destination.match(/\d/g);
        numb = numb ? numb.join(""): null;
        let key = numb && numb.length > 4 ? 'outgoing' : slugify(call.destination, '_');

        if(callTypes[key]){
          callTypes[key].counter++
        }
        else{
          callTypes[key] = call;
          callTypes[key].destination = key == 'outgoing' ? 'Uitgaand' : call.destination;
          callTypes[key].counter = 1;
        }
      })

      this.callTypes = _.orderBy(Object.keys(callTypes).map(key => { return callTypes[key]; }), ['counter'],['desc']);

      let internalCalls = {
        number: 0,
        seconds: 0,
        unanswered: 0
      }

      let hours = {
        0:{ hour: 0, number: 0, unanswered:0, incoming:0},
        1:{ hour: 1, number: 0, unanswered:0, incoming:0},
        2:{ hour: 2, number: 0, unanswered:0, incoming:0},
        3:{ hour: 3, number: 0, unanswered:0, incoming:0},
        4:{ hour: 4, number: 0, unanswered:0, incoming:0},
        5:{ hour: 5, number: 0, unanswered:0, incoming:0},
        6:{ hour: 6, number: 0, unanswered:0, incoming:0},
        7:{ hour: 7, number: 0, unanswered:0, incoming:0},
        8:{ hour: 8, number: 0, unanswered:0, incoming:0},
        9:{ hour: 9, number: 0, unanswered:0, incoming:0},
        10:{ hour: 10, number: 0, unanswered:0, incoming:0},
        11:{ hour: 11, number: 0, unanswered:0, incoming:0},
        12:{ hour: 12, number: 0, unanswered:0, incoming:0},
        13:{ hour: 13, number: 0, unanswered:0, incoming:0},
        14:{ hour: 14, number: 0, unanswered:0, incoming:0},
        15:{ hour: 15, number: 0, unanswered:0, incoming:0},
        16:{ hour: 16, number: 0, unanswered:0, incoming:0},
        17:{ hour: 17, number: 0, unanswered:0, incoming:0},
        18:{ hour: 18, number: 0, unanswered:0, incoming:0},
        19:{ hour: 19, number: 0, unanswered:0, incoming:0},
        20:{ hour: 20, number: 0, unanswered:0, incoming:0},
        21:{ hour: 21, number: 0, unanswered:0, incoming:0},
        22:{ hour: 22, number: 0, unanswered:0, incoming:0},
        23:{ hour: 23, number: 0, unanswered:0, incoming:0}
      }

      let queue = {
        number: 0,
        seconds: 0,
        unanswered: 0,
        week: {
          0:{
            number: 0,
            unanswered:0,
            hours: _.cloneDeep(hours),
            expanded: false
          },
          1:{
            number: 0,
            unanswered:0,
            hours: _.cloneDeep(hours),
            expanded: false
          },
          2:{
            number: 0,
            unanswered:0,
            hours: _.cloneDeep(hours),
            expanded: false
          },
          3:{
            number: 0,
            unanswered:0,
            hours: _.cloneDeep(hours),
            expanded: false
          },
          4:{
            number: 0,
            unanswered:0,
            hours: _.cloneDeep(hours),
            expanded: false
          },
          5:{
            number: 0,
            unanswered:0,
            hours: _.cloneDeep(hours),
            expanded: false
          },
          6:{
            number: 0,
            unanswered:0,
            hours: _.cloneDeep(hours),
            expanded: false
          }
        },
        unansweredWeek: 0,
        waiting: {
          longest: null,
          list: [],
          below60: 0,
          below120: 0,
          below180: 0,
          below300: 0,
          below600: 0,
          below900: 0,
          above900: 0
        }
      }

      let outgoingCalls = {
        number: 0,
        seconds: 0,
        unanswered: 0
      }

      let incomingCalls = {
        number: 0,
        seconds: 0,
        unanswered: 0,
        incoming: 0,
        logs: [],
        week: {
          0:{
            number: 0,
            incoming:0,
            hours: _.cloneDeep(hours),
            expanded: false
          },
          1:{
            number: 0,
            incoming:0,
            hours: _.cloneDeep(hours),
            expanded: false
          },
          2:{
            number: 0,
            incoming:0,
            hours: _.cloneDeep(hours),
            expanded: false
          },
          3:{
            number: 0,
            incoming:0,
            hours: _.cloneDeep(hours),
            expanded: false
          },
          4:{
            number: 0,
            incoming:0,
            hours: _.cloneDeep(hours),
            expanded: false
          },
          5:{
            number: 0,
            incoming:0,
            hours: _.cloneDeep(hours),
            expanded: false
          },
          6:{
            number: 0,
            incoming:0,
            hours: _.cloneDeep(hours),
            expanded: false
          }
        },
      }

      let urgencyCalls = {
        number: 0,
        seconds: 0,
        unanswered: 0,
        inTime: 0,
        overTime: 0,
        times: [],
        average: null,
        successRate: null,
        chartPercentage: 0,
        chartType: null
      }

      let callCounter = 0;

      if(this.calls.length > 0){

        new Promise((resolve)=>{
          this.calls.forEach(call=>{

            // 1. Wie belt wie
            // Kijken of uitgaande intern is
            let companyOutgoing = false;
            let companyIncoming = false;
            let companyQueue = false;
            let companyUrgency = false;
            let counter = 0;
            new Promise((resolve)=>{
              this.checkIncomingCallBigQuery('phone', call.callerId).then((result)=>{
                companyOutgoing = result;
                counter++
                if(counter == 3){
                  resolve();
                }
              })
              this.checkIncomingCallBigQuery('phone', call.destination).then((result)=>{
                companyIncoming = result;
                counter++
                if(counter == 3){
                  resolve();
                }
              })
              this.checkIncomingCallBigQuery('queue', call.destination).then((result)=>{
                companyQueue = result;
                counter++
                if(counter == 3){
                  resolve();
                }
              })
              this.checkIncomingCallBigQuery('urgency', call.destination).then((result)=>{
                companyUrgency = result;
                counter++
                if(counter == 3){
                  resolve();
                }
              })
            })
            .then(()=>{

              // console.log(callCounter + call.callerId +": companyOutgoing", companyOutgoing, "companyIncoming", companyIncoming, "companyQueue", companyQueue)

              if((companyOutgoing && companyIncoming) || (companyOutgoing && companyQueue)){
                // Intern gesprek
                internalCalls.number++
               
                if((!call.status && call.talking != 'unanswered') || (call.status && call.status != 'unanswered')){
                  let hours = Number(moment(call.talking, "HH:mm:ss").format("HH"))*60*60;
                  let minutes = Number(moment(call.talking, "HH:mm:ss").format("mm"))*60;
                  let seconds = Number(moment(call.talking, "HH:mm:ss").format("ss"))+ hours + minutes;
                  internalCalls.seconds = internalCalls.seconds + seconds;
                }
                else{
                  internalCalls.unanswered++
                }
              }
              else if(companyOutgoing){
                // Uitgaand gesprek
                outgoingCalls.number++
                if((!call.status && call.talking != 'unanswered') || (call.status && call.status != 'unanswered')){
                  let hours = Number(moment(call.talking, "HH:mm:ss").format("HH"))*60*60;
                  let minutes = Number(moment(call.talking, "HH:mm:ss").format("mm"))*60;
                  let seconds = Number(moment(call.talking, "HH:mm:ss").format("ss"))+ hours + minutes;
                  outgoingCalls.seconds = outgoingCalls.seconds + seconds;
                }
                else{
                  outgoingCalls.unanswered++
                }
              }
              else if(companyIncoming || companyQueue){
                // Incomming call
                let day = moment(call.timestamp.value).format("e")
                if(companyQueue){
                  // Incomming call naar queue
                  if(call.talking == 'unanswered' && call.talking != "00:00:00"){
                    this.queueCalls.push(call)
                  }
                 
                  // check if weekday
                  queue.number++
                  queue.week[day].number++
                  queue.week[day].hours[moment(call.timestamp.value).utcOffset(0).format("H")].number++
                  if((!call.status && call.talking != 'unanswered') || (call.status && call.status != 'unanswered')){
                    let hours = Number(moment(call.talking, "HH:mm:ss").format("HH"))*60*60;
                    let minutes = Number(moment(call.talking, "HH:mm:ss").format("mm"))*60;
                    let seconds = Number(moment(call.talking, "HH:mm:ss").format("ss"))+ hours + minutes;
                    queue.seconds = queue.seconds + seconds;
                    queue.waiting.list.push(seconds)

                  }
                  else{
                    queue.unanswered++
                    queue.week[day].unanswered++
                    queue.week[day].hours[moment(call.timestamp.value).utcOffset(0).format("H")].unanswered++
                    this.unansweredQueueCalls.push(call)
                  }
                }
                else{
                  incomingCalls.number++
                  incomingCalls.week[day].number++
                  incomingCalls.week[day].incoming++
                  incomingCalls.week[day].hours[moment(call.timestamp.value).utcOffset(0).format("H")].incoming++
                  incomingCalls.week[day].hours[moment(call.timestamp.value).utcOffset(0).format("H")].number++
                  // Incomming call opgenomen
                  if((!call.status && call.talking != 'unanswered') || (call.status && call.status != 'unanswered')){
                    let hours = Number(moment(call.talking, "HH:mm:ss").format("HH"))*60*60;
                    let minutes = Number(moment(call.talking, "HH:mm:ss").format("mm"))*60;
                    let seconds = Number(moment(call.talking, "HH:mm:ss").format("ss"))+ hours + minutes;
                    incomingCalls.seconds = incomingCalls.seconds + seconds;
                    incomingCalls.logs.push(call);
                  }
                  else{
                    incomingCalls.unanswered++
                  }
                }
              }
              
              else if (companyUrgency){
                
                // Spoed gesprek
                urgencyCalls.number++
                if((!call.status && call.talking != 'unanswered') || (call.status && call.Status != 'Unanswered')){
                  let time = call.ringing != "00:00:00" ? call.ringing : call.talking;
                  let hours = Number(moment(time, "HH:mm:ss").format("HH"))*60*60;
                  let minutes = Number(moment(time, "HH:mm:ss").format("mm"))*60;
                  let seconds = Number(moment(time, "HH:mm:ss").format("ss"))+ hours + minutes;
                  urgencyCalls.seconds = urgencyCalls.seconds + seconds;
                  urgencyCalls.times.push(seconds)

                  if(seconds < 30){
                    urgencyCalls.inTime++
                  }
                  else{
                    urgencyCalls.overTime++
                  } 
                }
                else{
                  // Niet beantwoord
                  urgencyCalls.unanswered++
                }
              }

              callCounter++
              if(callCounter == this.calls.length){
                resolve();
              }
            })
          })
        })
        .then(()=>{
          internalCalls.average = (internalCalls.number - internalCalls.unanswered) > 0 ? this.calculateTime((internalCalls.seconds / (internalCalls.number - internalCalls.unanswered)).toFixed(0)) : 0;
          queue.average = queue.number ? this.calculateTime((queue.seconds / (queue.number - queue.unanswered)).toFixed(0)) : null;
          outgoingCalls.average = (outgoingCalls.number - outgoingCalls.unanswered) > 0 ?this.calculateTime((outgoingCalls.seconds / (outgoingCalls.number - outgoingCalls.unanswered)).toFixed(0)) : 0;
          incomingCalls.average = (incomingCalls.number - incomingCalls.unanswered) > 0 ? this.calculateTime((incomingCalls.seconds / (incomingCalls.number - incomingCalls.unanswered)).toFixed(0)): 0;
          urgencyCalls.times.sort(function(a, b){return b - a});

          urgencyCalls.successRate =  (urgencyCalls.number - urgencyCalls.unanswered) > 0 ? ((urgencyCalls.inTime / (urgencyCalls.number - urgencyCalls.unanswered)) * 100) : 0;

          if(urgencyCalls.successRate < 100){
            if(urgencyCalls.successRate > 98){
              urgencyCalls.chartPercentage = 75 + (12.5 * (urgencyCalls.successRate - 98));
              urgencyCalls.chartType = 'three';
            }
            else if(urgencyCalls.successRate > 95){
              urgencyCalls.chartPercentage = 50 + (8.5 * (urgencyCalls.successRate - 95));
              urgencyCalls.chartType = 'two';
            }
            else{
              urgencyCalls.chartPercentage = 0.5 * urgencyCalls.successRate;
              urgencyCalls.chartType = 'one';
            }
          }
          else{
            urgencyCalls.chartPercentage = 100;
            urgencyCalls.chartType = 'three';
          }

          urgencyCalls.average = urgencyCalls.number ? this.calculateTime((urgencyCalls.seconds / (urgencyCalls.number)).toFixed(0)): 0;
          if(queue.waiting.list.length > 0){
            queue.waiting.list.sort(function(a, b){return b - a});
            queue.waiting.list.forEach(item=>{
              if(item < 60){
                queue.waiting.below60++
              }
              else if(item < 120){
                queue.waiting.below120++
              }
              else if(item < 180){
                queue.waiting.below180++
              }
              else if(item < 300){
                queue.waiting.below300++
              }
              else if(item < 600){
                queue.waiting.below600++
              }
              else if(item < 900){
                queue.waiting.below900++
              }
              else if(item >= 900){
                queue.waiting.above900++
              }
            })
            queue.waiting.longest = this.calculateTime(queue.waiting.list[0])
          }

          
          
          // Gemiddelde gesprekstijd
          this.internalCalls = internalCalls;
          this.queue = queue;
          this.outgoingCalls = outgoingCalls
          this.incomingCalls = incomingCalls;
          this.urgencyCalls = urgencyCalls;
          // console.log("internalCalls: ", internalCalls)
          // console.log("queue: ", queue)
          // console.log("outgoingCalls: ", outgoingCalls)
          // console.log("incomingCalls: ", incomingCalls)
          let missedCalls = _.cloneDeep(this.unansweredQueueCalls)
          if(missedCalls.length > 0){
            this.calls.forEach(call=>{
              missedCalls.forEach((item, index)=>{
                if(item.callerId == call.callerId){
                  if(item.timestamp.value < call.timestamp.value){
                    if(call.talking != 'unanswered'){
                      this.unansweredQueueCallsData.success = this.unansweredQueueCallsData.success +1;
                      missedCalls.splice(index, 1);
                    }
                    else{
                      this.unansweredQueueCallsData.failed = this.unansweredQueueCallsData.failed +1;
                    }
                  }
                }
              })
            })
          }

          this.dataLoading = false;
        })
      }
      else{
        this.internalCalls = internalCalls;
        this.queue = queue;
        this.outgoingCalls = outgoingCalls
        this.incomingCalls = incomingCalls;
        this.noDataLogs = true;
        this.dataLoading = false;
      }
      
    },

    calculateTime(timeInSeconds){
      let average = "";
      let hours = Math.floor(((timeInSeconds/60)/60)).toFixed(0)
      let minutes = Math.floor(((timeInSeconds - hours * 60 * 60)/60)).toFixed(0)
      let seconds = timeInSeconds - ((hours * 60 * 60)+ minutes * 60);

      average = moment(hours, "H").format("HH") + ":" + moment(minutes, "m").format("mm") + ":" + moment(seconds, "s").format("ss")
      return average;
    },




    filterCallSubjects(){
      this.noDataPopup = false;
      this.chartSeries[0].data = [];
      this.chartOptions.xaxis.categories = [];
      this.chartOptions.xaxis.tickAmount = 0;

      let hours = {
          0:{ hour: 0, number: 0, unanswered:0},
          1:{ hour: 1, number: 0, unanswered:0},
          2:{ hour: 2, number: 0, unanswered:0},
          3:{ hour: 3, number: 0, unanswered:0},
          4:{ hour: 4, number: 0, unanswered:0},
          5:{ hour: 5, number: 0, unanswered:0},
          6:{ hour: 6, number: 0, unanswered:0},
          7:{ hour: 7, number: 0, unanswered:0},
          8:{ hour: 8, number: 0, unanswered:0},
          9:{ hour: 9, number: 0, unanswered:0},
          10:{ hour: 10, number: 0, unanswered:0},
          11:{ hour: 11, number: 0, unanswered:0},
          12:{ hour: 12, number: 0, unanswered:0},
          13:{ hour: 13, number: 0, unanswered:0},
          14:{ hour: 14, number: 0, unanswered:0},
          15:{ hour: 15, number: 0, unanswered:0},
          16:{ hour: 16, number: 0, unanswered:0},
          17:{ hour: 17, number: 0, unanswered:0},
          18:{ hour: 18, number: 0, unanswered:0},
          19:{ hour: 19, number: 0, unanswered:0},
          20:{ hour: 20, number: 0, unanswered:0},
          21:{ hour: 21, number: 0, unanswered:0},
          22:{ hour: 22, number: 0, unanswered:0},
          23:{ hour: 23, number: 0, unanswered:0}
        }

      if(this.callSubjects.length > 0){
        let data = {}
        let counter = 0;
        new Promise((resolve)=>{
          this.callSubjects.forEach(subject=>{
            // hours[moment(subject.timestamp.value).utcOffset(0).format("H")].number++
            // console.log("tijdstip: ", moment(subject.timestamp.value).utcOffset(0).format("H"))
            if(data[subject.type]){
              data[subject.type].number = data[subject.type].number + 1;
            }
            else{
              data[subject.type] = {
                type: subject.type,
                number: 1
              }
            }
            counter++
            if(counter == this.callSubjects.length){
              resolve()
            }
          })
        })
        .then(()=> {
          // console.log("Hours: ", hours)
          let dataSorted = _.orderBy(data, 'number', 'desc');

          for (const [key, value] of Object.entries(dataSorted)) {
            let label = value.type;
            if(this.popupChartLabels[this.activeCompData.type][value.type]){
              // label = `${this.popupChartLabels[this.activeCompData.type][value.type]} (${value.number})`
              // label = `${this.popupChartLabels[this.activeCompData.type][value.type]}`
              label = `${this.popupChartLabels[this.activeCompData.type][value.type]} (${((value.number / this.callSubjects.length) * 100).toFixed(0)}%)`
            }
            this.chartSeries[0].data.push(value.number);
            this.chartOptions.xaxis.categories.push(label);
          }
          this.chartHeight = (this.chartOptions.xaxis.categories.length * 35)+74;
          // console.log("Hoogste data: ", dataSorted[0].number)
          if(dataSorted[0].number > 10){
            // console.log("tickAmount: 10")
            this.chartOptions.xaxis.tickAmount = 10;
          }
          else{
            // console.log("tickAmount:", dataSorted[0].number);
            this.chartOptions.xaxis.tickAmount = dataSorted[0].number;
          }
          this.callSubjectsLoading = false;
          this.calculateChartWidth();
        })
      }
      else{
        this.noDataPopup = true;
        this.callSubjectsLoading = false;
      }
      
    },

    // Initialize data structures
    initializeQueueData() {
        const hours = this.createHoursObject();
        return {
            number: 0,
            seconds: 0,
            unanswered: 0,
            week: Array.from({length: 7}, () => ({
                number: 0,
                unanswered: 0,
                hours: _.cloneDeep(hours),
                expanded: false
            })),
            unansweredWeek: 0,
            waiting: {
                longest: null,
                list: [],
                below60: 0,
                below120: 0,
                below180: 0,
                below300: 0,
                below600: 0,
                below900: 0,
                above900: 0
            }
        };
    },

    initializeIncomingCallsData() {
        const hours = this.createHoursObject();
        return {
            number: 0,
            seconds: 0,
            unanswered: 0,
            incoming: 0,
            logs: [],
            week: Array.from({length: 7}, () => ({
                number: 0,
                incoming: 0,
                hours: _.cloneDeep(hours),
                expanded: false
            }))
        };
    },

    initializeUrgencyCallsData() {
        return {
            number: 0,
            seconds: 0,
            unanswered: 0,
            inTime: 0,
            overTime: 0,
            times: [],
            average: null,
            successRate: null,
            chartPercentage: 0,
            chartType: null
        };
    },

    createHoursObject() {
        return Array.from({length: 24}, (_, hour) => ({
            hour,
            number: 0,
            unanswered: 0,
            incoming: 0
        })).reduce((obj, item) => {
            obj[item.hour] = item;
            return obj;
        }, {});
    },

    updateCallTypes(call, callTypes) {
      if(call.DestinationDn){
        const destination = call.DestinationDn;
        const numb = destination.match(/\d/g);
        const numbStr = numb ? numb.join("") : null;
        const key = numbStr && numbStr.length > 4 ? 'outgoing' : slugify(destination, '_');

        if (callTypes[key]) {
            callTypes[key].counter++;
        } else {
            callTypes[key] = {
                ...call,
                destination: key === 'outgoing' ? 'Uitgaand' : destination,
                counter: 1
            };
        }
      }
    },

    processInternalCall(call, seconds, data) {
        data.internalCalls.number++;
        if (call.Answered) {
            data.internalCalls.seconds += seconds;
        } else {
            data.internalCalls.unanswered++;
        }
    },

    processOutgoingCall(call, seconds, data) {
        data.outgoingCalls.number++;
        if (call.Answered) {
            data.outgoingCalls.seconds += seconds;
        } else {
            data.outgoingCalls.unanswered++;
        }
    },

    processIncomingOrQueueCall(call, seconds, data, isQueue) {
        const day = moment(call.StartTime).format("e");
        const hour = moment(call.StartTime).format("H");
        
        if (isQueue) {
            this.processQueueCall(call, seconds, day, hour, data);
        } else {
            this.processRegularIncomingCall(call, seconds, day, hour, data);
        }
    },

    processQueueCall(call, seconds, day, hour, data) {
        const { queue } = data;
        queue.number++;
        queue.week[day].number++;
        queue.week[day].hours[hour].number++;

        // if (seconds > 0 && (call.ActionType != 5 && call.ActionType != 6)) {
        if (seconds > 0 && (call.Status !== 'Unanswered')) {
          
            data.queueCalls.push(call);
            queue.seconds += seconds;
            queue.waiting.list.push(seconds);
        } else {
            queue.unanswered++;
            queue.week[day].unanswered++;
            queue.week[day].hours[hour].unanswered++;
            data.unansweredQueueCalls.push(call);
        }
    },

    processRegularIncomingCall(call, seconds, day, hour, data) {
        const { incomingCalls } = data;
        incomingCalls.number++;
        incomingCalls.week[day].number++;
        incomingCalls.week[day].incoming++;
        incomingCalls.week[day].hours[hour].incoming++;
        incomingCalls.week[day].hours[hour].number++;

        if (call.Answered) {
            incomingCalls.seconds += seconds;
            incomingCalls.logs.push(call);
        } else {
            incomingCalls.unanswered++;
        }
    },

    processUrgencyCall(call, seconds, data) {
        const { urgencyCalls } = data;

        urgencyCalls.number++;

        if (call.Status != "Unanswered") {
            const ringingSeconds = this.extractSeconds(call.RingingDuration);
            urgencyCalls.seconds += ringingSeconds;
            urgencyCalls.times.push(ringingSeconds.toFixed(2));
            if (ringingSeconds < 30) {
                urgencyCalls.inTime++;
            } else {
                urgencyCalls.overTime++;
            }
        } else {
            urgencyCalls.unanswered++;
        }
    },

    calculateFinalStatistics(data) {
        this.calculateAverages(data);
        this.calculateUrgencyStatistics(data);
        this.calculateQueueStatistics(data);
    },

    calculateAverages(data) {
        const { internalCalls, queue, outgoingCalls, incomingCalls } = data;
        
        internalCalls.average = this.calculateTimeAverage(
            internalCalls.seconds,
            internalCalls.number - internalCalls.unanswered
        );
        
        queue.average = this.calculateTimeAverage(
            queue.seconds,
            queue.number - queue.unanswered
        );
        
        outgoingCalls.average = this.calculateTimeAverage(
            outgoingCalls.seconds,
            outgoingCalls.number - outgoingCalls.unanswered
        );
        
        incomingCalls.average = this.calculateTimeAverage(
            incomingCalls.seconds,
            incomingCalls.number - incomingCalls.unanswered
        );
    },

    calculateTimeAverage(seconds, count) {
        return count > 0 ? this.calculateTime((seconds / count).toFixed(0)) : 0;
    },

    calculateUrgencyStatistics(data) {
        const { urgencyCalls } = data;
        urgencyCalls.times.sort((a, b) => b - a);
        
        const answeredCalls = urgencyCalls.number - urgencyCalls.unanswered;
        urgencyCalls.successRate = answeredCalls > 0 
            ? ((urgencyCalls.inTime / answeredCalls) * 100) 
            : 0;

        this.calculateUrgencyChartData(urgencyCalls);
    },

    calculateUrgencyChartData(urgencyCalls) {
        if (urgencyCalls.successRate >= 100) {
            urgencyCalls.chartPercentage = 100;
            urgencyCalls.chartType = 'three';
        } else if (urgencyCalls.successRate > 98) {
            urgencyCalls.chartPercentage = 75 + (12.5 * (urgencyCalls.successRate - 98));
            urgencyCalls.chartType = 'three';
        } else if (urgencyCalls.successRate > 95) {
            urgencyCalls.chartPercentage = 50 + (8.5 * (urgencyCalls.successRate - 95));
            urgencyCalls.chartType = 'two';
        } else {
            urgencyCalls.chartPercentage = 0.5 * urgencyCalls.successRate;
            urgencyCalls.chartType = 'one';
        }
    },

    calculateQueueStatistics(data) {
        const { queue } = data;
        if (queue.waiting.list.length > 0) {
            queue.waiting.list.sort((a, b) => b - a);
            this.categorizeWaitingTimes(queue.waiting);
            queue.waiting.longest = this.calculateTime(queue.waiting.list[0]);
        }
    },

    categorizeWaitingTimes(waiting) {
        waiting.list.forEach(seconds => {
            if (seconds < 60) waiting.below60++;
            else if (seconds < 120) waiting.below120++;
            else if (seconds < 180) waiting.below180++;
            else if (seconds < 300) waiting.below300++;
            else if (seconds < 600) waiting.below600++;
            else if (seconds < 900) waiting.below900++;
            else waiting.above900++;
        });
    },

    processMissedCalls(data) {
        const missedCalls = _.cloneDeep(data.unansweredQueueCalls);
        if (missedCalls.length === 0) return;

        this.calls.forEach(call => {
            missedCalls.forEach((item, index) => {
                if (this.isSameCallerLaterCall(item, call)) {
                    this.updateMissedCallStats(call, data, index, missedCalls);
                }
            });
        });
    },

    isSameCallerLaterCall(missedCall, currentCall) {
        const missedTime = moment(missedCall.StartTime);
        const currentTime = moment(currentCall.StartTime);
        return missedCall.callerId === currentCall.callerId && missedTime.isBefore(currentTime);
    },

    updateMissedCallStats(call, data, index, missedCalls) {
      if (call.Answered && (call.Status == "Unanswered")) {
      // if (call.Answered && (call.ActionType == 104 || call.ActionType == 2 || call.ActionType == 101 )) {
          data.unansweredQueueCallsData.success++;
          missedCalls.splice(index, 1);
      } else {
          data.unansweredQueueCallsData.failed++;
      }
    },

    setEmptyData(data) {
        Object.assign(this, {
            internalCalls: data.internalCalls,
            queue: data.queue,
            outgoingCalls: data.outgoingCalls,
            incomingCalls: data.incomingCalls,
            noDataLogs: true,
            dataLoading: false
        });
    },

    updateComponentData(data) {
        Object.assign(this, {
            internalCalls: data.internalCalls,
            queue: data.queue,
            outgoingCalls: data.outgoingCalls,
            incomingCalls: data.incomingCalls,
            urgencyCalls: data.urgencyCalls,
            unansweredQueueCalls: data.unansweredQueueCalls,
            unansweredQueueCallsData: data.unansweredQueueCallsData,
            queueCalls: data.queueCalls,
            dataLoading: false
        });
    }
  },

  computed: {
    selectAllExtentions () {
      return this.selectedExtentions.length === this.extentions.length
    },
    selectSomeExtentions () {
      return this.selectedExtentions.length > 0 && !this.selectAllExtentions
    },
    icon () {
      if (this.selectAllExtentions) return 'mdi-close-box'
      if (this.selectSomeExtentions) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },

    currentMonth(){
      return Number(moment().format("M"));
    },

    months(){
      let months = [
        { id: 1, name: "Januari", disabled: false },
        { id: 2, name: "Februari", disabled: false },
        { id: 3, name: "Maart", disabled: false },
        { id: 4, name: "April", disabled: false },
        { id: 5, name: "Mei", disabled: false },
        { id: 6, name: "Juni", disabled: false },
        { id: 7, name: "Juli", disabled: false },
        { id: 8, name: "Augustus", disabled: false },
        { id: 9, name: "September", disabled: false },
        { id: 10, name: "Oktober", disabled: false },
        { id: 11, name: "November", disabled: false },
        { id: 12, name: "December", disabled: false },  
      ];
      if(this.selectedPeriodYear == Number(moment().format("YYYY"))){
        months.forEach(month=>{
          if(month.id > Number(this.currentMonth)){
            month.disabled = true
          } 
          else if(this.activeCompData.created && (this.selectedPeriodYear == Number(moment.unix(this.activeCompData.created.seconds).format("YYYY")))){
            if(month.id < Number(moment.unix(this.activeCompData.created.seconds).format("M"))){
              month.disabled = true
            }
          } 
        })
        return months
      }
      else if(this.selectedPeriodYear == this.compStartYear){
        months.forEach(month=>{
          if(month.id < this.compStartMonth){
            month.disabled = true
          } 
        })
        return months
      } else{
        return months
      }
    },

    activeYears(){
      let currentYear = Number(moment().year());
      let today = moment().format("YYYY-MM-DD")
      let startDateCompany = moment.unix(this.activeCompData.created.seconds).format("YYYY-MM-DD");
      let startDateCompanyYear =  Number(moment.unix(this.activeCompData.created.seconds).format("YYYY"));
      let startYear = currentYear;

      if(currentYear > startDateCompanyYear){
        startYear = startDateCompanyYear;
      }

      let numberOfYears = Math.ceil(moment(today).diff(moment(startDateCompany), 'years', true)) + 1;
      let activeYears = Array.apply(null, Array(numberOfYears))
      let counter = 0

      activeYears.forEach((year, index)=>{
        activeYears[index] = currentYear - counter
        counter++
      })
      return activeYears
    },

    todaySelected(){
      let data = {
        color: this.$vuetify.theme.themes[this.theme].menuborder,
        textColor: this.$vuetify.theme.themes[this.theme].text,
        loading: false
      }
      if(this.filterToday && this.dataLoading){
        data.color = this.companyPrimaryColor;
        data.textColor = "#fff";
        data.loading = true
      } else if(this.filterToday){
        data.color = this.companyPrimaryColor;
        data.textColor = "#fff";
      } 
      return data
    },

    weekSelected(){
      let data = {
        color: this.$vuetify.theme.themes[this.theme].menuborder,
        textColor: this.$vuetify.theme.themes[this.theme].text,
        loading: false
      }
      if(this.filterWeek && this.dataLoading){
        data.color = this.companyPrimaryColor;
        data.textColor = "#fff";
        data.loading = true
      } else if(this.filterWeek){
        data.color = this.companyPrimaryColor;
        data.textColor = "#fff";
      } 
      return data
    },

    monthSelected(){
      let data = {
        color: this.$vuetify.theme.themes[this.theme].menuborder,
        textColor: this.$vuetify.theme.themes[this.theme].text,
        loading: false
      }
      if(this.filterMonth && this.dataLoading){
        data.color = this.companyPrimaryColor;
        data.textColor = "#fff";
        data.loading = true
      } else if(this.filterMonth){
        data.color = this.companyPrimaryColor;
        data.textColor = "#fff";
      } 
      return data
    },

    customPeriodSelected(){
      let data = {
        color: this.$vuetify.theme.themes[this.theme].menuborder,
        textColor: this.$vuetify.theme.themes[this.theme].text,
        loading: false
      }
      if(this.filterCustom.active && this.dataLoading){
        data.color = this.companyPrimaryColor
        data.textColor = "#fff";
        data.loading = true
      } else if(this.filterCustom.active){
        data.color = this.companyPrimaryColor
        data.textColor = "#fff";
      } 
      return data
    },
    
    periodSelected(){
      let data = {
        color: this.$vuetify.theme.themes[this.theme].menuborder,
        textColor: this.$vuetify.theme.themes[this.theme].text,
        loading: false
      }
      if(this.filterPeriod && this.dataLoading){
        data.color = this.companyPrimaryColor
        data.textColor = "#fff";
        data.loading = true
      } else if(this.filterPeriod){
        data.color = this.companyPrimaryColor
        data.textColor = "#fff";
      } 
      return data
    },
    dateRangeText () {
      return this.selectedDates.join(' t/m ')
    },

    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    userBranches() {
      return this.$store.state.userBranches;
    },
    userId() {
      return this.$store.state.userId;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    companyPrimaryColorRGBA() {
      return this.$store.state.companyPrimaryColorRGBA;
    },
    companySecondaryColorRGBA() {
      return this.$store.state.companySecondaryColorRGBA;
    },
    demoMode(){
      return this.$store.state.demoMode;
    },

    // filteredCompanies(){
    //   if(this.searchCompanies && this.searchCompanies.length > 0){
    //     return this.companies.filter(company => {
    //       return company.name.toLowerCase().includes(this.searchCompanies.toLowerCase());
    //     });
    //   } else {
    //     return this.companies
    //   }
    // },

    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },

    filteredCompanies(){
      return this.companies.filter(company => {
        return company.name.toLowerCase().includes(this.searchCompanies.toLowerCase());
      });
    },

    randomMedical(){
      if(this.noDataLogs){
        let randomNumber = Math.floor(Math.random() * 7) + 1;
        let medicalClass = "medical-" + randomNumber
         return medicalClass
      } else {
        return null
      }    
    },

    filterButtonDisabled(){
      if((this.selectedPeriodYear == moment().year() && this.currentMonth < this.selectedPeriodMonth) || this.selectedPeriodYear == this.compStartYear && this.selectedPeriodMonth < this.compStartMonth){
        return true
      } else {
        return false
      }
    },
  }
};
</script>

<style>
.no-data{
  width: 280px;
  margin: 0px auto;
  padding: 80px 0;
}

.medical-image{
  width: 200px;
  height: 200px;
  margin: 0 auto;
}

.no-data p{
  font-weight: 600;
  text-align: center;
  font-size: 16px;
}

.medical-1{
  background: url('../assets/medical/medical-1.png') no-repeat center center;
  background-size: 180px auto;
}
.medical-2{
  background: url('../assets/medical/medical-2.png') no-repeat center center;
  background-size: 180px auto;
}
.medical-3{
  background: url('../assets/medical/medical-3.png') no-repeat center center;
  background-size: 180px auto;
}
.medical-4{
  background: url('../assets/medical/medical-4.png') no-repeat center center;
  background-size: 180px auto;
}
.medical-5{
  background: url('../assets/medical/medical-5.png') no-repeat center center;
  background-size: 180px auto;
}
.medical-6{
  background: url('../assets/medical/medical-6.png') no-repeat center center;
  background-size: 180px auto;
}
.medical-7{
  background: url('../assets/medical/medical-7.png') no-repeat center center;
  background-size: 180px auto;
}

/*
<div class="unanswered-days-wrapper">
    <div class="unanswered-days">
      <div class="unanswered-label"> Zondag: </div>
      <div class="unanswered-data-wrapper" v-if="queue.week[5].number">
        <div class="unanswered-data" :style="{width : ((queue.week[5].unanswered / queue.week[5].number)*100).toFixed(0) +'%'}">
        
        </div>
        <div class="unanswered-data-number">
          {{ ((queue.week[5].unanswered / queue.week[5].number)*100).toFixed(0) }}%
        </div>

      </div>
      <div v-else class="unanswered-data-wrapper empty">-</div>

    </div>
  </div>

 */

.unanswered-hours-wrapper{
  margin: 5px 0 0 0;
  padding: 3px;
  background-color: var(--v-background-base);
}

.unanswered-days-wrapper{
  width: 100%;
  padding: 3px 0;
}

.unanswered-hour{
  margin: 2px 0;
}


.unanswered-hour:after,
.unanswered-days:after,
.unanswered-hours-wrapper:after,
.unanswered-days-wrapper:after{
  content: "";
  display: block;
  clear: both;
 }

.unanswered-label{
  width: 95px;
  float: left;
  font-weight: 600;
  font-size: 15px;
  overflow: hidden;
 }

.unanswered-label.hours{
  width: 92px;
  font-weight: 500;
  font-size: 13px;
}

.unanswered-number{
  width: 35px;
  float: left;
  height: 22px;
  line-height: 22px;
  font-weight: 400;
  font-size: 11px;
  overflow: hidden;
 }

.unanswered-data-wrapper{
  width: calc(100% - 170px);
  float: left;
  position:relative;
  height: 22px;
  background-color: var(--v-background-base);
 }

.unanswered-data-wrapper.hours{
  width: calc(100% - 167px);
  height: 18px;
  background-color: var(--v-menu-base);
}

.expand-hours{
  float: left;
  width: 30px;
  height: 21px;
}

.unanswered-data-wrapper.empty{
  background: none!important;
}

.unanswered-data-number{
  top: 0;
  height: 22px;
  font-weight: 600;
  font-size: 14px;
  width: 100%;
  position: absolute;
  line-height: 22px;
  text-align: center;
}
.unanswered-data-number.medium{
  color: #d3e1e8;
}

.unanswered-data-number.large{
  color: #ffffff;
}


.unanswered-data-number.hours{
  height: 18px;
  font-size: 12px;
  line-height: 18px;
}

.unanswered-data{
  position:relative;
  height: 22px;
  background: #2580c3;
}

.unanswered-data.hours{
  height: 18px;
}

.extention-name{
  font-weight: 600;
  padding: 0 0 0 3px;
}

.v-list-item--disabled{
  opacity: 0.3;
  cursor: not-allowed;
}

.v-list-item--disabled:hover{
  cursor: not-allowed!important;
}

.traffic-light-chart-wrapper{
  width: 100%;
  padding: 20px;
  position: relative
}

.traffic-light-chart{
  width: 100%;
  position: relative
}
.traffic-light-chart:after{
  display: block;
  clear: both;
  content: ""
}

.traffic-light{
  float: left;
  height: 36px;
  position: relative
}

.traffic-light-chart.one .traffic-light.one{
  background-color: #e85a5c!important;
  box-shadow: 0 0 10px rgba(232,90,92,0.5);
}

.traffic-light.one{
  background-color: #f7d5d6;
  width: 50%
}

.traffic-light.one:before{
  position: absolute;
  top: 0;
  left: 0;
  margin: 0;
  width: 34px;
  padding: 0 0 0 3px;
  height: 60px;
  line-height: 105px;
  font-size: 14px;
  border-left: 2px solid #4b4b4b;
  display: block;
  content: "0%";
}

.traffic-light-chart.dark .traffic-light.one:before,
.traffic-light-chart.dark .traffic-light.two:before,
.traffic-light-chart.dark .traffic-light.three:before,
.traffic-light-chart.dark .traffic-light.three:after{
  border-color: #f9f9f9!important;
}

.traffic-light-chart.two .traffic-light.two{
  background-color: #ffb200!important;
  box-shadow: 0 0 10px rgba(255, 178, 0,0.5);
}

.traffic-light.two{
  background-color: #feecbf;
  width:25%
}

.traffic-light.two:before{
  position: absolute;
  top: 0;
  left: 0;
  margin: 0 0 0 -34px;
  width: 34px;
  height: 60px;
  line-height: 105px;
  font-size: 14px;
  border-right: 2px solid #4b4b4b;
  display: block;
  content: "95%";
}

.traffic-light-chart.three .traffic-light.three{
  background-color: #25cf70!important;
  box-shadow: 0 0 10px rgba(37, 207, 112,0.5);
}

.traffic-light.three{
  background-color:#ccf4da;
  width: 25%
}

.traffic-light.three:after{
  position: absolute;
  top: 0;
  right: 0;
  margin:  0;
  width: 42px;
  height: 60px;
  line-height: 105px;
  font-size: 14px;
  border-right: 2px solid #4b4b4b;
  display: block;
  content: "100%";
}
.traffic-light.three:before{
  position: absolute;
  top: 0;
  left: 0;
  margin: 0px 0 0px -34px;
  width: 34px;
  height: 60px;
  line-height: 105px;
  font-size: 14px;
  border-right: 2px solid #4b4b4b;
  display: block;
  content: "98%";
}

.traffic-light.status{
  position: absolute;
  height: 16px;
  top: 10px;
  left: 0;
  background-color: #4b4b4b;
}

.traffic-light-chart.dark .traffic-light.status{
  background-color: #f9f9f9;
}

</style>
